function P_Error() {
  document.title = 'Error | iamcatraz'
  return (
    <center>
      <div
        className='card'
        style={{
          width: '80vw',
          marginTop: '20vh',
          backgroundColor: 'rgba(255, 255, 255, 0.2)',
          backdropFilter: 'blur(10px)',
        }}>
        <div className='card-body text-dark'>
          <h5 className='card-title'>
            Oh Dear, Something went wrong and this page could not be loaded!
          </h5>
        </div>
      </div>
    </center>
  )
}

export default P_Error
